var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEwalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6.5a2 2 0 0 1 2-2h11.429c.066 0 .1 0 .127.003a.5.5 0 0 1 .44.441c.004.028.004.061.004.127 0 .398 0 .597-.019.765a3 3 0 0 1-2.645 2.645c-.168.019-.367.019-.765.019H15m-10.5-2a2 2 0 0 0 2 2h11c.943 0 1.414 0 1.707.293.293.293.293.764.293 1.707v2m-15-6v9c0 1.886 0 2.828.586 3.414.586.586 1.528.586 3.414.586h9c.943 0 1.414 0 1.707-.293.293-.293.293-.764.293-1.707v-1m0 0h-2c-.943 0-1.414 0-1.707-.293-.293-.293-.293-.764-.293-1.707 0-.943 0-1.414.293-1.707.293-.293.764-.293 1.707-.293h2m0 4v-4",
    stroke: "#B0B6BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEwalletIcon);
export default __webpack_public_path__ + "static/media/ewallet-icon.352a4f9c9c5d3af8dd4022aa253c23b9.svg";
export { ForwardRef as ReactComponent };